import { toast } from "react-toastify"

export function validateFields (objectSubmit: any) {
    for (const key in objectSubmit) {
        if(!objectSubmit[key]){
            if(!objectSubmit[key]){
                toast.error('Preencha os campos para cadastrar!')
                return false;
            } 
            if(typeof objectSubmit[key] === "number" && objectSubmit[key] <= 0) {
                toast.error('Preencha os campos para cadastrar!')
                return false
            }
        }
    }

    return true;
}